import { useState, useCallback } from 'react';
import axiosInstance from '../axios/axiosInstance';

export function usePath(url) {
  const [result, setResult] = useState('');

  const resetResult = () => {
    setResult('');
  };

  const pathsCall = useCallback(async (data, id = null) => {
    try {
      if (id) {
        const res = await axiosInstance.patch(`${url}/${id}/`, data);
        setResult({ sucess: true });
      } else {
        const res = await axiosInstance.post(`${url}/`, data);
        setResult({ sucess: true });
      }
    } catch (error) {
      if (error.code === 'ERR_NETWORK') {
        return setResult({ error: 'ERR_NETWORK' });
      }
      const err = error.response?.data;
      return setResult({ error: err });
    }
  }, []);

  return { result, pathsCall, resetResult };
}
